import { Endpoint } from '../endpoint';

export const ProcessingRuleUsageView = new Endpoint('processing_rule_usage_view');
